import { Component, ViewEncapsulation, Input, Output } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
       selector: 'cfa-menu-item',
    template: '<ng-content></ng-content>',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CfaMenuItem {
    @Input() label: string;
    @Input() textOnly = false;
    @Input() disabled = false;
    @Input() routerLink: string;

    @Output() selected = new Subject<void>();
}
